import React from 'react';

import Plasticmachiner from './Plasticmachiner';
import Factorycover from './Factorycover';
import Machinefact from './Machinefact';
import Globalagents from './Globalagents';


const Contacts = () => {
  return (
    <div>
     <Plasticmachiner />
            <Factorycover />
            <Machinefact />
            <Globalagents />
    </div>
  );
};

export default Contacts;
